(() => {
  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => [...root.querySelectorAll(sel)];
const money = (cents) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format((Number(cents) || 0) / 100);
};
  function init(root) {
    const variantsNode = qs(root, '[data-cdb-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
    const add = qs(root, '[data-cdb-pdp-add]');
    const stickyAdd = qs(root, '[data-cdb-pdp-sticky-add]');
    const qtyInput = qs(root, '[data-cdb-pdp-qty-input]');
    const price = qs(root, '[data-cdb-pdp-price]');
    const stickyPrice = qs(root, '[data-cdb-pdp-sticky-price]');
    const status = qs(root, '[data-cdb-pdp-status]');
    const buybox = qs(root, '.cdb-pdp__buybox');
    let selectedVariant = variants.find(v => String(v.id) === String(add?.dataset.variantId)) || variants[0];

    const selectedOptions = () => qsa(root, '[data-option-position]').map(field => qs(field, '.cdb-pdp__option-button.is-selected')?.dataset.optionValue || '');
    const findVariant = () => {
      const options = selectedOptions();
      return variants.find(v => options.every((value, index) => String(v.options?.[index] ?? '') === String(value)));
    };
    const updateVariant = (variant) => {
      if (!variant) return;
      selectedVariant = variant;
      if (add) add.dataset.variantId = variant.id;
      if (price) price.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      const available = Boolean(variant.available);
      [add, stickyAdd].filter(Boolean).forEach(btn => { btn.disabled = !available; btn.textContent = available ? 'Thêm vào giỏ' : 'Tạm hết hàng'; });
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    };

    root.addEventListener('click', (event) => {
      const option = event.target.closest('.cdb-pdp__option-button');
      if (option) {
        const field = option.closest('[data-option-position]');
        qsa(field, '.cdb-pdp__option-button').forEach(btn => { btn.classList.toggle('is-selected', btn === option); btn.setAttribute('aria-pressed', btn === option ? 'true' : 'false'); });
        updateVariant(findVariant());
        return;
      }
      if (event.target.closest('[data-cdb-pdp-qty-minus]')) { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); return; }
      if (event.target.closest('[data-cdb-pdp-qty-plus]')) { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1); return; }
      if (event.target.closest('[data-cdb-pdp-sticky-add]')) add?.click();
    });

    qtyInput?.addEventListener('input', () => { qtyInput.value = qtyInput.value.replace(/[^0-9]/g, ''); });
    qtyInput?.addEventListener('change', () => { qtyInput.value = String(Math.max(1, parseInt(qtyInput.value, 10) || 1)); });
    qtyInput?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); qtyInput.blur(); } });

    add?.addEventListener('click', async () => {
      if (!selectedVariant?.id || add.disabled) return;
      const quantity = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      add.disabled = true;
      if (status) { status.textContent = 'Đang thêm vào giỏ…'; status.classList.remove('is-error'); }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity }] })
        });
        if (!response.ok) { const e = await response.json().catch(() => ({})); throw new Error(e.description || 'Không thể thêm sản phẩm.'); }
        if (window.CDBCart?.sync) await window.CDBCart.sync();
        if (status) status.textContent = `Đã thêm ${quantity} sản phẩm vào giỏ.`;
      } catch (error) {
        if (status) { status.textContent = error.message || 'Không thể thêm vào giỏ.'; status.classList.add('is-error'); }
      } finally {
        add.disabled = !selectedVariant.available;
      }
    });

    const sticky = qs(root, '[data-cdb-pdp-sticky]');
    if (sticky && buybox && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => sticky.classList.toggle('is-visible', !entries[0].isIntersecting), { threshold:0.1 });
      observer.observe(buybox);
    }

    if (selectedVariant) updateVariant(selectedVariant);
  }

  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-cdb-pdp]').forEach(init));
})();
